import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "/reevesdotnl/ab6bc2de142a21e0ffbcbfe46ebdcd18/Methodology.gif",
        "alt": "Global data-sets"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`The work described here addresses two questions: `}</p>
    <p>{`(1). How did the constituent continents of Gondwana originally fit together precisely?`}</p>
    <p>{`(2). Can we define `}<em parentName="p">{`exactly`}</em>{` the pathways by which the continents dispersed to reach their present-day positions?`}</p>
    <p>{`We worked from first principles with the latest data to build a model that is as independent as possible from previously published work, particularly before 83 Ma. The global data, geophysical and geological, that provided the constraints to building our geodynamic model are illustrated in the above presentation. The applications of our modelling principles to the interpretation of the data are illustrated in the various animations. `}</p>
    <p>{`The entire work was conducted using the 'Atlas' software developed over many years by Cambridge Paleomap Services Ltd.  Without using this or similar software it is impossible to quantify ideas into a precise, Gondwana-wide context.  For those using similar software, our Euler rotation parameters are listed under `}<a parentName="p" {...{
        "href": "../latest-rotation"
      }}>{`Global thoughts`}</a>{`.`}</p>
    <p><em parentName="p">{`Updated: 2024 February 1`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      